import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { alertCancel, alertDone, handleClose, handleTabsClick } from '../../action/index';
import { updateAlertMessage } from '../../redux/reducers/utils.js';
import CustomPopup from './CustomPopup.js';
import { resetErrorhandling } from '../../action/order.action.js';


const PaymentError = () => {
    const dispatch = useDispatch()
    const state =  useSelector(state=>state.orderReducer)
    return(
        <>
            <CustomPopup isPopupOpen={state.errorPayment} onClosePopup={() => dispatch(resetErrorhandling())} >
                <h2>Alert!!</h2>
                <p>{state.alertUsedMSG}</p>
                <div className='button-sec'>
                    <button className='solid-btn' onClick={() => dispatch(resetErrorhandling())}>          
                    <span className="text">Ok</span> 
                    </button>
                </div>
            </CustomPopup>
        </>
    )
}
export default PaymentError;